module.exports = __webpack_public_path__ + "img/chat-green-solid.d00a916.svg";